// extracted by mini-css-extract-plugin
export default {"container":"UT06sl","floatingText":"aplRex"};